import { render, staticRenderFns } from "./JustificationTicketForm.vue?vue&type=template&id=8e0a38d6&scoped=true"
import script from "./JustificationTicketForm.vue?vue&type=script&lang=js"
export * from "./JustificationTicketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0a38d6",
  null
  
)

export default component.exports